'use client';

import { Box, Button, Container, useMediaQuery } from '@mui/material';
import { TagLabels } from '@repo-ui/components/TagLabels';
import { useLoginUser } from '@repo-ui/store/useAuthStore';
import theme from '@repo-ui/theme';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { PublicLectureList } from '../components/PublicLectureList';
import { SearchBar } from './components/SearchBar';
import CateRadioBtns from './components/CateRadioBtns';
import { toast } from 'react-toastify';

export default function OpenLectureListFeature() {
  const locale = useLocale();
  const [cate, setCate] = useState<string>();
  const isXsDown = useMediaQuery(theme.breakpoints.down('sm'));
  const { isLoggedIn } = useLoginUser();

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        mt: '60px',
      }}
    >
      <TagLabels
        currentTag={cate}
        tags={['블록코딩', '파이썬', '자바스크립트', 'P5.js']}
        undefinedLabel="전체"
        onChange={setCate}
      />
      <CateRadioBtns sx={{ mt: '20px' }} />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <SearchBar sx={{ mt: 1, mb: 1 }} />
        <Button
          variant="contained"
          sx={{
            whiteSpace: 'nowrap',
            ml: 2,
            '&.MuiButtonBase-root': {
              width: 124,
              height: 43,
            },
          }}
          onClick={() => toast.warn('준비중입니다.')}
        >
          강좌 만들기
        </Button>
      </Box>

      {/* 전체 강의 */}
      <PublicLectureList stampKind={undefined} cate={cate} />
    </Container>
  );
}
